<template lang="">
    <div class="team-form-card px-20">
      <h5 class="c-white text-center header-name mt-10 mb-20">TEAM FORM</h5>
      <section class="team-form-list mt-30">
        <div class="home" v-if="homeLastFive.length">
          <div class="result-row" v-for="game in homeLastFive" :key="game._id">
            <div class="d-flex gap-05 align-items-center justify-end mr-20">
              <span class="versus-text versus-name text-right">{{ getVersusTeamName('home', game) }}</span>
              <TeamLogo :team="getVersusTeam('home', game)" :small="true" class="versus-logo"  />
            </div>
            <div class="team-result c-white" :class="{ green: isWon('home', game), red: isLoss('home', game) }">{{ getResult('home', game )}}</div>
            <div class="versus-result c-white">{{ getVersusResult('home', game) }}</div>
            <!-- <span class="ml-10 text-center versus-text">v</span> -->
          </div>
        </div>
        <div class="empty-state" v-if="!homeLastFive.length">
          <div class="empty-content">
            <span class="empty-text">No recent games</span>
          </div>
        </div>
        <div class="away" v-if="awayLastFive.length">
          <div class="result-row" v-for="game in awayLastFive" :key="game._id">
            <div class="versus-result c-white">{{ getVersusResult('away', game) }}</div>
            <div class="team-result c-white" :class="{ green: isWon('away', game), red: isLoss('away', game) }" >{{ getResult('away', game )}}</div>
            <!-- <span class="ml-10 text-center versus-text">v</span> -->
            <div class="d-flex gap-05 align-items-center pl-20">
              <TeamLogo :team="getVersusTeam('away', game)" :small="true" class="versus-logo"  />
              <span class="versus-text versus-name">{{ getVersusTeamName('away', game) }}</span>
            </div>
            <!-- <TeamLogo :team="getVersusTeam('away', game)" :small="true"  /> -->
          </div>
        </div>
        <div class="empty-state" v-if="!awayLastFive.length">
          <div class="empty-content">
            <span class="empty-text">No recent games</span>
          </div>
        </div>
      </section>
    </div>
  </template>
    
<script>
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import TeamLogo from '../../views/matches/base/team-logo'
    
export default {
  name: 'TeamFormCard',
  props: {
    homeId: {
      type: Number,
      required: false
    },
    awayId: {
      type: Number,
      required: false,
    }
  },
  components: {
    TeamLogo,
  },
  data() {
    return {
      moment,
      upperCase: _.upperCase,
      get: _.get,
      find: _.find,
    }
  },
  computed: {
    ...mapGetters('match', ['homeLastFive', 'awayLastFive'])
  },  
  mounted() {
  },  
  methods: {
    isLoss(teamType, game) {
      const teamId = this[`${teamType}Id`];
      const isHomeTeam = game.homeTeam?._id === teamId;
      const homeScore = game.scores.homeTeam;
      const awayScore = game.scores.awayTeam;
      if (isHomeTeam) {
        return homeScore < awayScore;
      } else {
        return awayScore < homeScore;
      }
    },
    isWon(teamType, game) {
      const teamId = this[`${teamType}Id`];
      const isHomeTeam = game.homeTeam?._id === teamId;
      const homeScore = game.scores.homeTeam;
      const awayScore = game.scores.awayTeam;
      if (isHomeTeam) {
        return homeScore > awayScore;
      } else {
        return awayScore > homeScore;
      }
    },
    getVersusTeam(teamType, game) {
      const teamId = this[`${teamType}Id`]; // Dynamically access homeId or awayId based on teamType
      const isHomeTeam = game.homeTeam?._id === teamId;
      const team = isHomeTeam ? game.awayTeam : game.homeTeam;
      return team;
    },
    getVersusTeamName(teamType, game) {
      const teamId = this[`${teamType}Id`];
      const isHomeTeam = game.homeTeam?._id === teamId;
      const teamName = isHomeTeam ? _.get(game, 'awayTeam.name', '') : _.get(game, 'homeTeam.name', '');
      return teamName.length 
        ? teamName 
        : 'TBD'
    },
    getResult(teamType, game) {
      const teamId = this[`${teamType}Id`];
      const isHomeTeam = game.homeTeam?._id === teamId;
      return isHomeTeam ? game.scores.homeTeam : game.scores.awayTeam;
    },
    getVersusLogo(teamType, game) {
      const teamId = this[`${teamType}Id`];
      const isHomeTeam = game.homeTeam?._id === teamId;
      return isHomeTeam ? game.awayTeam.imgUrl : game.homeTeam.imgUrl;
    },
    getVersusResult(teamType, game) {
      const teamId = this[`${teamType}Id`];
      const isHomeTeam = game.homeTeam?._id === teamId;
      return isHomeTeam ? game.scores.awayTeam : game.scores.homeTeam;
    },
    formatDateTime(timestamp) {
      const isTomorrow = moment().add(1, 'day').isSame(timestamp, 'day');
      const isToday = moment().isSame(timestamp, 'day');
      const time = moment(timestamp).format('h:mm A');
      if (isToday) {
        return moment(timestamp).format('h:mm A');
      } else if (isTomorrow) {
        return `Tomorrow ${time}`;
      } else {
        return moment(timestamp).format('ddd, MMM D');
      }
    }
  }
}
</script>
    
<style lang="scss" scoped>

  .team-form-card {
    // margin: 0 1rem;
    margin-bottom: 1rem;
    background: #171717;
    border-radius: 24px;
    padding: 1rem 1.5rem;
    max-width: 768px;
    @media (min-width: 768px) {
      min-width: 768px;
      .versus-name {
        font-size: 0.9rem;
      }
    }

    @media (max-width: 768px) {
      // min-width: 728px;
      .versus-logo {
        display: none;
      }

      .versus-name {
        font-size: 0.75rem;
      }
    }


    .header-name {
      font-size: 1rem;
      font-family: 'BrownStd-Bold';
      letter-spacing: -0.05rem;
      color: #F0F2F5;
    }
    
    .team-form-list {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;

      .empty-state {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 6rem;
        
        .empty-content {
          text-align: center;
          
          .empty-text {
            color: #6B7280;
            font-size: 0.875rem;
            letter-spacing: -0.025em;
            opacity: 0.8;
          }
        }
      }

      .home {
        .result-row {
          grid-template-columns: 1fr 1.25rem 1.25rem;
        }
      }
      

      .result-row {
        display: grid;
        grid-template-columns: 1.25rem 1.25rem 1fr;
        gap: 0.5rem;
        margin-bottom: 1rem;
        // align-items: center;

        .versus-logo {
          border-radius: 200px;
          width: 1.5rem;
          height: 1.5rem;
        }

        .versus-text { 
          color: #D1D9E1;
        }

        .team-result, .versus-result {
          border-radius: 6px;
          background: #393D42;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 1.25rem;
          height: 1.25rem;
          font-size: 0.75rem;
          color: #a1a1a1;
        }

        .green {
          background: #66CC90;
          color: #1F2123;
        }

        .red {
          background: #DB7070;
          color: #1F2123;
        }
      }
    }
  }

  .bold-title {
    max-width: none;
  }
  .custom-card {
    border-radius: 24px;
    cursor: pointer;
    font-family: 'BrownStd-Regular';
    font-size: 1.2rem;
    line-height: 137.4%;
    letter-spacing: 0.02em;
    color: white;
    background: #171717 !important;
    &:hover {
      background: hsl(225, 6%, 14%) !important;
    }
    margin-inline: 1.5rem;
    margin-bottom: 1rem;

    .venue {
      letter-spacing: -0.01rem;
    }

    padding: 0.5rem;
  }

ion-badge {
  border-radius: 200px;
  height: 1.75rem;
}

.date-time {
  margin-top: 0.5rem;
  margin-bottom: -0.25rem;
}

.team-name {
  font-family: 'BrownStd-Regular';
  color: #ebebeb;
}

.score-text {
  font-size: 1.3rem;
}


.custom-card .card-content-ios {
  padding: 10px;
}

.custom-card .promoted-header {
  font-family: 'BrownStd-Regular';
  text-align: center;
  font-size: .9rem;
  font-weight: 600;
  text-transform: capitalize;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: #2d3a45;
}

.list-ios, .list-md {
  padding: 0;
  background: 0;
}
</style>